import { render, staticRenderFns } from "./RankChart.vue?vue&type=template&id=50307af9&scoped=true"
import script from "./RankChart.vue?vue&type=script&lang=js"
export * from "./RankChart.vue?vue&type=script&lang=js"
import style0 from "./RankChart.vue?vue&type=style&index=0&id=50307af9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50307af9",
  null
  
)

export default component.exports